module.exports = __webpack_public_path__ + "svg/bg-hero-small.svg";